import React from 'react'
import { Button, Col, Row } from 'reactstrap'

const ToxicologyAccurateScreening = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem py-md-5 py-4'>
            <div className=''>
                <text className='fs-ss-32-1 text-montserrat text-ss-primary fw-700 lh-1-2'>
                    <center>
                        Accurate And Reliable Toxicology Screening
                    </center>
                </text>
                <div className='flex-center my-2'>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>

            <div className='pb-md-5 pb-4'>
                <text className='fs-ss-20-1 text-montserrat text-ss-black fw-600' style={{ fontStyle:'italic'}}>
                   <center>
                        Most of the time, a blood or urine sample is used for toxicology screening.
                    </center>
                </text>
            </div>

            <div className='left-padding10rem1 right-padding10rem1'>
                <Row className='d-flex justify-content-center'>
                    <Col xs='12' sm='' md='6' lg='5' className='pb-md-0 pb-4'>
                        <div className='bg-im bgc p-img1' style={{ backgroundPosition:'center', backgroundSize:'', backgroundRepeat:'no-repeat', backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2023/05/ULC-Toxicology-Testing-widget-bg1-v1.png")', padding:''  }}>
                            <div className='tox-img1'>
                            <div className=''>
                                <center>
                                    <img src='https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Blood-Test-icon.png' alt='Blood Test' height='auto' width='60px' />
                                </center>
                            </div>
                            <div className='fs-ss-22 text-montserrat fw-700 text-ss-secondary pt-3 pb-4'>
                                <center>
                                    Blood Test
                                </center>
                            </div>
                            <div className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                <center>
                                    When the needle is embedded to draw blood, specific individuals feel moderate pain, while others feel just a prick or stinging sensation.
                                </center>
                            </div>
                        </div>
                        </div>
                    </Col>

                    <Col md='6' lg='5' className=''>
                        <div className='bg-im bgc p-img2' style={{ backgroundPosition:'center', backgroundSize:'', backgroundRepeat:'no-repeat',backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2023/05/ULC-Toxicology-Testing-widget-bg1-v1.png")', padding:'' }}>
                            <div className=''>
                                <center>
                                    <img src='https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Urine-Test-icon.png' alt='Blood Test' height='auto' width='60px' />
                                </center>
                            </div>
                            <div className='fs-ss-22 text-montserrat fw-700 text-ss-secondary pt-3 pb-4'>
                                <center>
                                    Urine Test
                                </center>
                            </div>
                            <div className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                <center>
                                Normal urination is required for a urine test. There is no unpleasantness.                                </center>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='pt-md-5 pt-4' style={{ }}>
                <div className='bg-img rounded30 py-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='py-4 px-md-5 px-lg-0 px-4'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            Let Us Conduct Full Toxicology Panels On Your Patients!
                        </center>
                    </text>    
                    </div>

                    <div className='pb-3 pt-md-2'>
                        <center>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'12px 14px',}}>
                                    Contact Us
                                </text>
                            </Button>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ToxicologyAccurateScreening